import React, { useState } from 'react';
import AutoScroller from './AutoScroller';
import { whoAccepted, offerOrder, isGameOver, Chat, Offer, Showdown, Action, Move, PlayerState, HouseState, PlayOutcome } from '../common/logic';
import { round } from '../common/math';
import MoveBar from './MoveBar';

interface OfferDetailsProps {
	username: string;
	isProposal: boolean;
	play: PlayerState;
	offer: number[];
	onOffer: (split: number[]) => void;
}

function OfferDetails({username, isProposal, play, offer, onOffer}: OfferDetailsProps) {
	const [show, setShow] = useState(isProposal);
	const players = play.players;
	const accepted = whoAccepted(play, offer);
	const Iaccepted = accepted.includes(username)! as boolean;

	const rows = players.map((playerName: string, i: number) =>
		<tr key={i}>
		<td> {playerName} </td>
		<td className="NoWrap"> {round(offer[i] * 100, 2)}% </td>
		<td> {accepted.includes(playerName) ? '✓' : ''} </td>
		</tr>
	);

	const acceptButton = (
		<button style={ Iaccepted ? {display: 'none'} : {} }
		        onClick={() => {onOffer(offer)} }>
			✓ &nbsp; Accept
		</button>
	);

	return (<>
		<button onClick={() => setShow(!show)}>
			{show ? '-' : '+'} &nbsp; Details
		</button>
		<div style={ show ? {} : {display: 'none'} }>
		<div className="table-container">
		<table>
		<tr> <th>Player</th> <th>Split</th> <th>Accepted</th> </tr>
		{rows}
		</table>
		</div>
		{acceptButton}
		</div>
		</>
	);
}

interface MoveBoardProps {
	username: string;
	play: PlayerState;
	onOffer: (split: number[]) => void;
}

function MoveBoard({ username, play, onOffer }: MoveBoardProps) {
	const { players, history } = play;
	const items = history.map((move: Move, i: number) => {
		if (move.action.actionType == "chat")
			return (
				<li key={i}>
					<b>{move.player}:</b> &nbsp;
					{move.action.message}
				</li>
			);

		if (move.action.actionType == "offer") {
			const split = move.action.split;
			const me = players.indexOf(username)!;
//			const him = players.indexOf(move.player);
			const isProposal = offerOrder(play, split)[0] == move.player;
			const offerText = (isProposal ?
				<> <b>{move.player}</b> made an offer. </>
				: <> <b>{move.player}</b> accepted an offer. </>
			)
			const splitText = <>
				You would get {round(split[me] * 100, 2)}%.
				</>;
			const detailsProps = {username, isProposal, play, offer: split, onOffer};
			return (
				<li key={i}>
					{offerText}
					{splitText}
					<OfferDetails {...detailsProps} />
				</li>
			);
		}

		if (move.action.actionType == "showdown")
			return(
				<li key={i}>
				{move.player} triggered a showdown.
				</li>
			);

		return <> </>;
	})

	return (<ul>
		{items}
		</ul>
	);
}

interface GameProps {
	mode: string;
	username: string;
	play: PlayerState;
	onAction: (action: Action) => void;
}

export default function Game({mode, username, play, onAction}: GameProps) {
	if (mode != "game")
		return <></>;

	function onSendMessage(msg: string) {
		onAction({ actionType: "chat", message: msg } as Chat);
	}

	function onOffer(split: number[]) {
		onAction({ actionType: "offer", split } as Offer);
	}

	function onShowdown() {
		onAction({ actionType: "showdown" } as Showdown);
	}

	return (
	<AutoScroller>
		<header>
			<h2>Your hand: {round(play.hand * 1000)}</h2>
		</header>
		<main>
			<MoveBoard username={username} play={play} onOffer={onOffer}/>
			<MoveBar username={username} play={play} onSendMessage={onSendMessage} onOffer={onOffer} onShowdown={onShowdown} />
		</main>
	</AutoScroller>
	);
}

